"use client";

import React from "react";
import { motion } from "framer-motion";
import { Banknote, Car, CircleCheck as CheckCircle2, MessageSquare, Receipt, Wind } from 'lucide-react';
import { Card, CardContent } from "@/components/ui/card";
interface BenefitItem {
  id: string;
  title: string;
  description: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
const benefits: BenefitItem[] = [{
  id: "upfront-rates",
  title: "Verbindliche Festpreise",
  description: "Erfahren Sie Ihren genauen Fahrpreis vor Reiseantritt – garantiert ohne versteckte Gebühren oder Zuschläge.",
  icon: Receipt
}, {
  id: "private-rides",
  title: "Private Fahrten",
  description: "Exklusive Fahrzeugnutzung, die ausschließlich Ihnen und Ihren Mitreisenden vorbehalten ist.",
  icon: Car
}, {
  id: "air-conditioned",
  title: "Klimatisierte Fahrzeuge",
  description: "Moderne, saubere und voll klimatisierte Fahrzeuge für eine angenehme Fahrt auf jeder Strecke.",
  icon: Wind
}, {
  id: "whatsapp-communication",
  title: "Einfache WhatsApp-Kommunikation",
  description: "Direkte, schnelle Informationen und reibungslose Abstimmung mit Ihrem Fahrer direkt auf Ihrem Smartphone.",
  icon: MessageSquare
}, {
  id: "payment-on-arrival",
  title: "Zahlung bei Ankunft",
  description: "Bequeme Bezahlung direkt bei Ihrem Fahrer, sobald Sie Ihr Ziel erreicht haben.",
  icon: Banknote
}, {
  id: "no-negotiations",
  title: "Keine Preisverhandlungen vor Ort",
  description: "Vermeiden Sie Preisverhandlungen vor Ort durch eine vorab vereinbarte Abholung und einen bestätigten Fahrpreis.",
  icon: CheckCircle2
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.06
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export default function WhyChooseUs() {
  return <section id="whychooseus" data-nav="light" className="bg-muted/40 text-foreground py-16 md:py-20 border-y border-border">
      <div className="max-w-[1136px] mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-accent-foreground font-default">
            Warum unseren Taxiservice wählen
          </h2>
        </div>

        <motion.div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: "-50px"
      }}>
          {benefits.map((item, index) => {
          const IconComponent = item.icon;
          return <motion.div key={item.id} data-index={index} variants={cardVariants} className="h-full">
                <Card className="h-full bg-card border-border rounded-xl shadow-xs transition-all duration-300 hover:shadow-md hover:border-primary/50 group py-6">
                  <CardContent className="flex flex-col items-start gap-4">
                    <div className="flex items-center justify-center size-12 rounded-xl bg-accent text-accent-foreground ring-1 ring-primary/20 transition-transform duration-300 group-hover:scale-105">
                      <IconComponent className="size-6 text-foreground" />
                    </div>
                    <div className="space-y-1.5">
                      <h3 className="text-lg font-semibold text-accent-foreground font-default">
                        {item.title}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}